import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid) as boolean;
  }
}

@Component({
  template: `<p class="form-error" [class.hide]="_hide">{{ _text }}</p>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./control-error.component.scss"],
})
export class ControlErrorComponent {
  _text!: string;
  _hide = true;

  @Input() set text(value: string) {
    if (value !== this._text) {
      this._text = value;
      this._hide = !value;
      this.changeDetectorRef.detectChanges();
    }
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {}
}
